if (!customElements.get('back-in-stock-form')) {
  class BackInStockForm extends HTMLElement {
    static COMPANY_ID = 'YwgYbZ';
    form = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      this.form?.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();
      this.subscribeToKlaviyo(event.target);

      // this.dispatchEvent(
      //   new CustomEvent(`${this.getAttribute('data-modal-id')}:toggle`, {
      //     bubbles: true,
      //   }),
      // );
    }

    subscribeToKlaviyo(form) {
      const { email } = form.elements;

      const variantId = document.querySelector(
        `[js-bis-id="${this.getAttribute('data-modal-id')}"]`,
      );

      this.submitButton.setAttribute('disabled', '');

      const formData = new FormData();
      formData.set('email', email.value);
      formData.set('variantId', variantId.value);

      fetch('/apps/bis/subscribe', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin',
      })
        .then((res) => res.json())
        .then((result) => {
          this.classList.toggle('is-subscribed', result.success);
          this.classList.toggle('is-error', !result.success);
        })
        .catch((err) => this.classList.add('is-error'))
        .finally(() => this.submitButton.removeAttribute('disabled'));
    }
  }
  customElements.define('back-in-stock-form', BackInStockForm);
}
